import { createSelector } from "reselect";

import { isFilteredProperty } from "../../../utils/map";
import getPropertyMarker from "../../../utils/getPropertyMarker";

const getMapProperties = createSelector(
  [
    (state) => state.properties.byId,
    (state) => state.dars.byPropertyId,
    (state) => state.mapFilter,
  ],
  (propertiesById, darsByPropertyId, mapFilter) => {
    const byId = {};
    const ids = [];
    for (const property of Object.values(propertiesById)) {
      if (property.isDeleted) {
        continue;
      }
      const propertyMarker = getPropertyMarker(property, darsByPropertyId);
      if (isFilteredProperty({ property: propertyMarker, filter: mapFilter })) {
        byId[propertyMarker.propertyId] = propertyMarker;
        ids.push(propertyMarker.propertyId);
      }
    }
    return { byId, ids };
  }
);

export default getMapProperties;
